import { linkButtonVariants } from "@/shared/components/LinkButton";
import { LinkArrowIcon } from "@/shared/components/LinkArrowIcon";
import { cn } from "@/lib/utils";

interface SearchSubmitButtonProps {
  className?: string;
}

export function SearchSubmitButton({ className }: SearchSubmitButtonProps) {
  return (
    <button
      type="submit"
      className={cn(linkButtonVariants({ variant: "linkArrow", size: "link" }), className)}
    >
      <span className="underline decoration-solid decoration-current underline-offset-4">
        Искать
      </span>
      <LinkArrowIcon />
    </button>
  );
}
